import { createContext } from "react";

export const GlobalContext = createContext();
export const AccomodationContext = createContext();